<style lang="scss" scoped>
    .dicom-study-item {
        position: relative;
        display: inline-block;
        border: 1px solid #d7dde4;
        box-sizing: border-box;
        vertical-align: top;
        margin-right: 10px;
        .dicom-title {
            position: absolute;
            background: #35B5E0;
            color: #fff;
            padding: 2px;
            border-radius: 0px 0px 10px 0px;
            top: 0px;
            left: 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
            line-height: 18px;
            &.woman {
                background: #fd6b84;
            }
        }
        .dicom-foot {
            position: absolute;
            background: #6F6F6F;
            color: #fff;
            padding: 2px 4px;
            border-radius: 10px 0px 0px 0px;
            bottom: 0px;
            right: 0px;
            line-height: 18px;
        }
        img {
            width: 100%;
            height: 100%;
        }
        .dicom-close {
            position: absolute;
            top: 2px;
            right: 2px;
            cursor: pointer;
            color: #FFF;
            &:hover {
                color: #d9534f;
            }
        }
    }
</style>
<template>
    <div class="dicom-study-item" :style="cardSize" @click="view">
        <span :class="['dicom-title',data.patientSex==2?'woman':'']">{{data.deviceType}}-{{data.patientAge}}岁</span>
        <img v-defaultimg="'DICOM'" :src="data.listId | dicomthumbnail" />
        <span class="dicom-foot">{{data.totalImage||data.imageCount}}张</span>
        <Icon class="dicom-close" @click.stop="remove" type="md-close"/>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                default () {
                    return {}
                }
            },
            size: {
                default: 80
            },
            show: {
                default: true
            }
        },
        // watch:{
        //     data:{
        //         handel(newval,oldval){
        //             console.log(newval,oldval)
        //         }
        //     }
        // },
        filters:{
            dicomthumbnail:function(value){
                return '/service/fileRes/dcmPicture?listId=' + value;
            }
        },
        directives: {
            defaultimg: {
                // 指令的定义
                update: function (el) {
                    var DEFAULT_IMG = {
                        DEFAULT : '/assets/img/nopic.png',
                        DICOM : '/assets/img/dicom-nopic.png',
                        AVATAR : '/assets/img/default-doctorhead.png'
                    };
                    var defaultImage = DEFAULT_IMG.DEFAULT;
                    el.onerror=()=>{
                        el.src = defaultImage;
                    }
                }
            }
        },
        computed: {
            cardSize() {
                return {
                    width: `${this.size}px`,
                    height: `${this.size}px`
                }
            },
            removeable() {
                return this.$el.hasAttribute('removeable');
            },
            closeBtn() {
                return !this.$el.hasAttribute('close');
            }
        },
        methods: {
            view() {
                if (this.$el.hasAttribute('viewable')) {
                    Base.openCateyes(this.data.listId, this.show)
                }
            },
            remove() {
                this.$emit('remove', this.data);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/dicomUploader/curd/widgets/DicomCard.vue